var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPoultryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7748 8.90897C19.7748 10.2296 18.74 12.8627 17.3836 14.2432C16.9854 12.2109 14.9927 10.2296 14.9927 8.90897C14.9927 7.58861 16.0633 6.51809 17.3836 6.51809C18.7042 6.51809 19.7748 7.58861 19.7748 8.90897Z",
    fill: "#00609B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1586 4.55185C15.7233 5.74526 15.9138 8.56813 15.2783 10.396C14.0489 8.72945 11.4006 7.79048 10.8357 6.5968C10.2711 5.40313 10.781 3.97775 11.9747 3.41285C13.1681 2.84822 14.5937 3.35817 15.1586 4.55185Z",
    fill: "#1592D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3797 3.44268C10.2605 4.14264 11.4677 6.22873 11.6693 7.86523C10.1029 7.05348 7.72507 7.33174 6.84456 6.63177C5.96379 5.93154 5.81735 4.65016 6.51759 3.76965C7.21755 2.88888 8.49893 2.74244 9.3797 3.44268Z",
    fill: "#00609B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89114 7.10355C13.8015 7.10355 17.7823 11.0841 17.7823 15.9944C17.7823 16.5894 17.7225 17.1702 17.6112 17.7324C16.1046 13.5887 12.7683 10.7057 8.89114 10.7057C8.79099 10.7057 8.6911 10.7076 8.5915 10.7114C6.88354 10.7772 5.45193 12.0242 5.15203 13.7069C4.85212 15.39 5.76402 17.0568 7.34477 17.7078L7.40431 17.7324H0.171062C0.0595438 17.1702 0 16.5894 0 15.9944C0 11.0841 3.98082 7.10355 8.89114 7.10355Z",
    fill: "#1592D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPoultryIcon);
export default __webpack_public_path__ + "static/media/Menu-PoultryIcon.d34f6d97ded39224251ae53aa42901d1.svg";
export { ForwardRef as ReactComponent };